import { useContext, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Context } from "../store/store"
import Alert from "./elements/Alert"
import Card from "./elements/Card"
import Confetti from "./elements/Confetti"
import Spinner from "./elements/Spinner"
import axios from "axios"
import { getEnvConfig } from "../env"
import { getRandomInt } from "../helper"
import { PRICE_TYPE, PROVIDERS } from "../config"

const MemoryGame = () => {
	const TimeToRender = 12
	const RANDOM_RANGE = 11

	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [err, setErr] = useState<null | string>(null)
	const [showWinDialog, setShowWinDialog] = useState<boolean>(false)
	const [showLoseDialog, setShowLoseDialog] = useState<boolean>(false)
	const { globalState, dispatch } = useContext(Context)

	const [gameState, setGameState] = useState<any>({})

	useEffect(() => {
		//console.log(gameState)
		if (Object.keys(gameState).length === 2) {
			setTimeout(() => {
				if (globalState.raffledPrizeCode === 0) {
					// Verloren
					setShowLoseDialog(true)
					setShowWinDialog(false)
				} else {
					// Gewonnen
					setShowWinDialog(true)
					setShowLoseDialog(false)
				}
			}, 500)
		}
		// eslint-disable-next-line
	}, [gameState])

	function updateGameState(cardIndex, data) {
		let tmpGameState = { ...gameState }
		tmpGameState[cardIndex] = data
		setGameState(tmpGameState)
	}

	function cardClick(cardIndex) {
		const numOfTurns = Object.keys(gameState).length

		if (isLoading === false) {
			if (!!!gameState[cardIndex]) {
				if (numOfTurns === 0) {
					loadWinData(cardIndex)
				} else if (numOfTurns === 1 && !isLoading) {
					showSecondCard(cardIndex)
				}
			}
		}
	}

	function loadWinData(cardIndex) {
		const env = getEnvConfig()

		setIsLoading(true)

		const formdata = new FormData()
		formdata.append("extID", globalState.extID)
		formdata.append("sessionID", globalState.sessionID)

		if (globalState.testActionCode && globalState.testActionCode.length > 0) {
			formdata.append("testActionCode", globalState.testActionCode)
		}

		try {
			const win: any = window
			win.dataLayer = win.dataLayer || []
			win.dataLayer.push({ event: "n2_mitspielen", sto_form_submit: true, sto_form_message: "memory start" })
		} catch (error) {}

		axios
			.post(env.apibase + "drawPrice.php?cv=" + Date.now(), formdata, {
				headers: {
					"content-type": "multipart/form-data",
					Accept: "application/json",
				},
			})
			.then(res => {
				dispatch({
					type: "SET_ENTRY",
					key: "raffledPrizeCode",
					value: res.data.raffledPrize,
				})

				// tracking

				if (res.data.raffledPrize === 0) {
					// trigger lose case
					try {
						const win: any = window
						win.dataLayer = win.dataLayer || []
						win.dataLayer.push({ event: "n2_memory", sto_memory: "verloren", sto_gewinn: "" })
					} catch (error) {}
				} else {
					// trigger win case
					try {
						const win: any = window
						win.dataLayer = win.dataLayer || []
						win.dataLayer.push({ event: "n2_memory", sto_memory: "gewonnen", sto_gewinn: res.data.raffledPrize })
					} catch (error) {}
				}

				if (PRICE_TYPE[res.data.raffledPrize].provider === PROVIDERS.LOST) {
					// show one the the lose cards
					updateGameState(cardIndex, { loseCardIndex: getRandomInt(RANDOM_RANGE).toString() })
				} else {
					// show winner card
					updateGameState(cardIndex, { winCardIndex: PRICE_TYPE[res.data.raffledPrize].provider })
				}
				setIsLoading(false)
			})
			.catch(err => {
				setIsLoading(false)
				//console.log(err)

				setErr("Es ist ein Fehler aufgetreten.")
			})
	}

	function getLoseCardIndex(obj): string {
		const keys = Object.keys(obj)

		for (let i = 0; i < keys.length; i++) {
			const key = parseInt(keys[i], 10)
			const value = obj[key]

			if (value.hasOwnProperty("loseCardIndex")) {
				return value.loseCardIndex
			}
		}

		return ""
	}

	function showSecondCard(cardIndex) {
		if (PRICE_TYPE[globalState.raffledPrizeCode].provider === PROVIDERS.LOST) {
			// show one the the lose cards

			const firstLoseCardIndex = parseInt(getLoseCardIndex(gameState))
			let loseCardIndex = getRandomInt(RANDOM_RANGE)

			if (loseCardIndex === firstLoseCardIndex) {
				loseCardIndex = (loseCardIndex + 1) % RANDOM_RANGE
			}
			updateGameState(cardIndex, { loseCardIndex: loseCardIndex.toString() })
		} else {
			// show winner card
			updateGameState(cardIndex, { winCardIndex: PRICE_TYPE[globalState.raffledPrizeCode].provider })
		}
	}

	return (
		<div className="relative max-w-3xl mx-auto">
			<p className="font-Museo text-center leading-normal lg:text-[28px]">Finde heraus, ob du gewonnen hast, indem du zwei Karten aufdeckst.</p>
			{err && <Alert className="mt-6">{err}</Alert>}

			<div className="grid grid-cols-3 md:grid-cols-4 gap-6 px-6 pt-6 lg:pt-12 ">
				{Array.from({ length: TimeToRender }).map((_, index) => (
					<Card cardKey={index} onClick={() => cardClick(index)} front={<img src="images/card.png" alt="" />} cardStatus={gameState[index]} />
				))}
			</div>

			{isLoading && (
				<div className="absolute left-1/2 top-1/2 -translate-x-1/2 translate-y-1/4">
					<Spinner />
				</div>
			)}
			{showWinDialog && (
				<>
					<Confetti />
					<div className="absolute top-1/2 lg:-mt-32 left-0 z-20 w-full px-4 text-center">
						<h2 className="h2 ">Du hast GEWONNEN!</h2>
						<div>
							<Link to="/bestaetigung">
								<button className="btn">weiter</button>
							</Link>
						</div>
					</div>
				</>
			)}
			{showLoseDialog && (
				<>
					<div className="fixed top-0 left-0 z-20 w-full h-full bg-black/60"></div>
					<div className="absolute top-0 left-0 z-20 w-full h-full px-4 text-center ">
						<div className="grid grid-cols-1 items-center h-full">
							<div>
								<h2 className="h2 ">Du hast leider verloren!</h2>
								<div>
									<Link to="/keinmatch">
										<button className="btn">weiter</button>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</>
			)}
		</div>
	)
}

export default MemoryGame
